import React, { Component } from 'react';
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';
import Cookies from 'js-cookie'

class ValidarLogin extends Component {
    constructor(props) {
        super(props);

        let cookie = Cookies.get('bG9naW4');
        // cookie = "eyJpZCI6IjExMTgyNiIsIm5vbWUiOiJEZXNlbnZvbHZpbWVudG8gLSBKb2FvIFJpY2FyZG8gQ2F2YWxpIFJpYmVpcm8iLCJlbWFpbCI6ImpvYW9fcmliZWlyb0BlY29uZXRlZGl0b3JhLmNvbS5iciIsImNvZGlnbyI6ImpvYW9fcmliZWlybyIsInRpcG9faWQiOiIxIiwiYmxfaW50ZXJubyI6dHJ1ZSwiaXBfdXN1YXJpbyI6IjE3Mi4yOS4xLjkxIiwiZGVtb25zdHJhdGl2byI6ZmFsc2UsImRlbW9uc3RyYXRpdm9fdmVuZGFzIjpmYWxzZSwidGltZXN0YW1wIjoxNzA5ODk1NDE0LCJkYXRhX2xvZ2luIjoiMjAyNC0wMy0wOCAwNzo1Njo1NCIsImlkX3VzdWFyaW9fY3VzdG9tX3RiIjoiIiwiaWRfYWRtaW5fcmVzcG9uc2F2ZWwiOiIiLCJpZF91c3VhcmlvX2Vjb25ldCI6IiIsImNvZF9jYWQiOm51bGwsInRpcG9fdXN1YXJpbyI6Ik9VVFJPUyIsInNlc3Npb25faWQiOiIxMTE4MjZlZWUyMDI0MDMwODA3NTY1NDE3MjI5MTkxIn0="
        
        /*
        Foi alterada a validacao do IsDemosntrativo.
        Agora est� sendo validado demonstrativo true, demonstrativo_vendas true ou tipo_id 7.
        Se a validacao for verdadeira ser� um acesso demonstrativo e aparecer� a modal de token.
        */
        if (cookie != undefined && cookie != "") {
            cookie = atob(cookie);
            cookie = JSON.parse(cookie);
            this.state = {
                idUsuario: cookie.id,
                isDemonstrativo: ((cookie.demonstrativo == true || cookie.demonstrativo_vendas == true)) || (cookie.tipo_id == "7") ? true : false,
            };

            this.logar();
        } else {

            if (this.props.params.idUsuario) {
                this.state = ({
                    idUsuario: this.props.params.idUsuario
                });

                this.logar();

            } else {

                window.location = 'https://www.econeteditora.com.br/user/ver_log.asp?Pag=http://www.econeteditora.com.br';
            }

        }
    };

    logar = () => {
        var codAcesso = this.state.isDemonstrativo ? '38048' : this.state.idUsuario;

        var url = `${Config.urls.API_URL_BASE}Acesso/ValidarDadosLogin/${codAcesso}/${this.state.isDemonstrativo}`;

            return new Promise((resolve, reject) => {
                HttpUtil.eco_GET(url, (response) => {
                    if (response.data == null || response.data == "") {
                        window.location = "/erro";
                    } else {
                        var roles = JSON.stringify(response.data.Roles);
                        var usuarioVendas = roles.indexOf("usuarioVendas") > -1;

                        localStorage.setItem("CodUsuario", response.data.CodUsuario);
                        localStorage.setItem("NomeUsuario", response.data.NomeUsuario);
                        localStorage.setItem("Login", response.data.Login);
                        localStorage.setItem("Email", response.data.Email);
                        localStorage.setItem("NomePerfil", response.data.NomePerfil);
                        localStorage.setItem("Administrador", response.data.Administrador);
                        localStorage.setItem("isSimulacao", false);
                        localStorage.setItem("TermoUso", response.data.TermoUso);
                        localStorage.setItem("roles", roles);
                        localStorage.setItem("usuarioVendas", usuarioVendas);
                        localStorage.setItem("Hash", response.data.Hash);
                        localStorage.setItem("isContribuicaoPiloto", response.data.isContribuicaoPiloto);
                        localStorage.setItem("ExibirNotificacaoArquivosRecentes", response.data.ExibirNotificacaoArquivosRecentes);
                        localStorage.setItem("isPro", response.data.isPro);
                        localStorage.setItem("Token", "");
                        localStorage.setItem("isDemonstrativo", response.data.isDemonstrativo);

                        /*Para a modal de token aparecer� para usuario que seja demonstrativo ou pro*/
                        if ((response.data.isPro) || (response.data.isDemonstrativo))
                            window.location = "/validar-token";
                        else
                            window.location = "/arquivos-recentes";
                    }
                }, () => { 
                    window.location = "/erro"; 
                }
                );
            });
    }

    render() {
        return null;
    }
}

export default ValidarLogin;


// WEBPACK FOOTER //
// ./src/Componente/ValidarLogin/ValidarLogin.jsx